/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-use-before-define */
import PropTypes from 'prop-types';
import { useMemo } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import palette from './palette';
import shadows from './shadows';
import typography from './typography';
import GlobalStyles from './globalStyles';
import customShadows from './customShadows';
import componentsOverride from './overrides';

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children, darkMode }) {
  const themeOptions = useMemo(
    () => ({
      palette: {
        ...palette,
      },
      shape: { borderRadius: 6 },
      typography,
      shadows: shadows(),
      customShadows: customShadows(),
    }),
    [],
  );

  const themeOptionsDark = {
    ...themeOptions,
    palette: {
      ...themeOptions.palette,
      mode: 'dark',
    },
  };

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  const darkTheme = createTheme(themeOptionsDark);
  darkTheme.components = componentsOverride(darkTheme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={darkMode ? darkTheme : theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
